import axios from 'axios';
import Storage from '../helpers/storage';
import env from '../config/env';

const headers = {
  'Content-Type': 'application/json',
  'Accept-Language': 'pt-BR',
};
class Merchant {
  get() {
    const merchant = Storage.getLocalStorage('merchant');
    const auth = Storage.getLocalStorage('auth');

    return axios.get(`${env.REACT_APP_MKTP_ENDPOINT}/unities/${merchant.idUnity}`, {
      headers: {
        authorization: `Bearer ${auth.accessToken}`,
      },
    });
  }

  updateDeliveryPersonally(data) {
    const merchant = Storage.getLocalStorage('merchant');
    const auth = Storage.getLocalStorage('auth');

    return axios.patch(
      `${env.REACT_APP_MKTP_ENDPOINT}/unities/${merchant.idUnity}/delivery-personally`,
      data,
      {
        headers: {
          ...headers,
          authorization: `Bearer ${auth.accessToken}`,
        },
      }
    );
  }

  updateEstimatedTimes(data) {
    const merchant = Storage.getLocalStorage('merchant');
    const auth = Storage.getLocalStorage('auth');
    return axios.put(
      `${env.REACT_APP_MKTP_ENDPOINT}/unities/${merchant.idUnity}/estimatedTimes`,
      data,
      {
        headers: {
          authorization: `Bearer ${auth.accessToken}`,
        },
      }
    );
  }
}

export default new Merchant();



// WEBPACK FOOTER //
// ./src/services/Merchant.js